// Pagine editoriali — FONTE UNICA del contenuto editabile da Piranha CMS per le pagine
// documentali (Privacy, Carta dei servizi, Trasparenza, ConciliaWeb).
//
// I dati arrivano da Piranha: lo snapshot pages.generated.json è prodotto al build da
// app/scripts/gen-pages.mjs (fetch all'API del CMS) ed è committato come fallback. I
// componenti e react-router (prerender) consumano questi export. Vedi ADR 0007.
import generated from './pages.generated.json'

// ---- mattoni condivisi ----

export interface DocHeader {
  eyebrowIcon?: string   // chiave Icons.* (fallback lato componente se assente/ignota)
  eyebrow: string
  title: string
  titleAccent?: string
  lead?: string
}

export interface MetaPill {
  icon: string
  text: string
}

export interface DownloadCta {
  icon?: string
  title: string
  text?: string
  ctaLabel: string
  ctaHref: string
  metaLabel?: string
}

export interface DownloadItem {
  name: string
  file: string   // solo il nomefile; l'URL base media è in TRASPARENZA_MEDIA_BASE
}

// Blocco del corpo (pagina editoriale a blocchi). `type` è il discriminante reso da DocBody.
export type DocBlock =
  | { type: 'html'; html: string }
  | { type: 'callout'; icon: 'bolt' | 'info'; html: string }
  | { type: 'specTable'; title: string; rows: { label: string; value: string }[] }
  | { type: 'pullquote'; text: string }
  | { type: 'codeblock'; title: string; language: string; code: string }

// ---- pagina editoriale generica (Privacy) ----

export interface EditorialPage {
  slug: string
  header: DocHeader
  intro?: string
  meta: MetaPill[]
  body: DocBlock[]
}

// ---- Carta dei servizi ----

export interface RegItem {
  source: string
  text: string
}

export interface CartaServiziPage {
  header: DocHeader
  intro?: string
  meta: MetaPill[]
  regTitle?: string
  regulations: RegItem[]
  download: DownloadCta
  footerCallout?: string
}

// ---- Trasparenza tariffaria ----

export interface DownloadGroup {
  icon?: string
  title: string
  items: DownloadItem[]
}

export interface TrasparenzaPage {
  header: DocHeader
  meta: MetaPill[]
  groups: DownloadGroup[]
  archiveTitle?: string
  archiveSubtitle?: string
  archive: DownloadItem[]
  footerCallout?: string
}

// ---- ConciliaWeb ----

export interface FlowStep {
  label: string
  title: string
  text: string
}

export interface Procedure {
  icon?: string
  tag: string
  title: string
  text: string
  meta?: string
  accent: boolean
}

export interface Step {
  title: string
  text: string
}

export interface NeedItem {
  icon: string
  title: string
  text: string
}

export interface Fact {
  icon: string
  big: string
  title: string
  text: string
}

export interface FaqEntry {
  question: string
  answer: string
}

export interface ConciliaWebPage {
  header: DocHeader
  intro?: string
  meta: MetaPill[]
  coseHtml?: string
  reclamoHtml?: string
  flow: FlowStep[]
  reclamoCallout?: string
  procedureHtml?: string
  procedures: Procedure[]
  comeHtml?: string
  steps: Step[]
  serveHtml?: string
  need: NeedItem[]
  facts: Fact[]
  download: DownloadCta
  footerCallout?: string
  faq: FaqEntry[]
}

// URL base dei PDF di trasparenza, serviti same-origin dal sito statico (public/media/); lo
// snapshot tiene solo il nomefile, l'URL si compone qui.
export const TRASPARENZA_MEDIA_BASE = '/media/'

interface PagesSnapshot {
  privacy?: EditorialPage
  cartaServizi?: CartaServiziPage
  trasparenza?: TrasparenzaPage
  conciliaweb?: ConciliaWebPage
}

const data = generated as PagesSnapshot

export const PRIVACY = data.privacy
export const CARTA_SERVIZI = data.cartaServizi
export const TRASPARENZA = data.trasparenza
export const CONCILIAWEB = data.conciliaweb
